var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.hasList)?_c(_setup.CycleCardList,{attrs:{"title":_setup.title,"modifiers":_setup.modifiers}},[_c('template',{slot:"list-items"},_vm._l((_setup.list),function(listItem,index){return _c(_setup.CycleListItem,{key:index},[_vm._v(" "+_vm._s(listItem)+" ")])}),1)],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }